import React from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import classnames from 'classnames';

class Widget extends React.Component {
  constructor(props) {
    super(props);
    this.slug = this.props.match.params.slug;
    this.state = {
      mentor: null,
      screenWidth: window.innerWidth,
    }
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.updateScreenWidth);

    let baseUrl = 'https://staging-api.sidetrain.com';

    if (process.env.REACT_APP_ENVIRONMENT === 'production') {
      baseUrl = 'https://api.sidetrain.com';
    }
    
    const url = `${baseUrl}/mentors/${this.slug}/profile`;
    console.log(url);
    axios.get(url)
      .then((response) => {
        this.setState({ mentor: response.data.mentor });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateScreenWidth);
  }

  updateScreenWidth = () => {
    this.setState({ screenWidth: window.innerWidth });
  };
  
  render() {
    if (!this.state.mentor) { return null }
    
    let baseUrl = 'https://staging.sidetrain.com';
    
    if (process.env.REACT_APP_ENVIRONMENT === 'production') {
      baseUrl = 'https://sidetrain.com';
    }
    
    const url = `${baseUrl}/mentors/${this.slug}`;

    let margins = 'm-8';
    let displayRates = 'flex';
    let paddings = 'p-6';
    let bookButtonClass = 'py-4 px-8 font-medium';
    let bookButtonMargins = 'my-4';
    
    if(this.state.screenWidth <= 400) {
      margins = 'm-4';
      displayRates = 'flex';
      paddings = 'p-4';
      bookButtonClass = 'py-4 px-4 font-medium';
      bookButtonMargins = 'my-4';
    }
    
    if(this.state.screenWidth <= 300) {
      margins = 'm-2';
      displayRates = 'block';
      paddings = 'p-2';
      bookButtonClass = 'py-2 px-4 font-medium';
      bookButtonMargins = 'my-4';
    }

    if(this.state.screenWidth <= 275) {
      margins = 'm-2';
      displayRates = 'block';
      paddings = 'p-2';
      bookButtonClass = 'py-2 px-4 text-sm';
      bookButtonMargins = 'my-4';
    }

    if(this.state.screenWidth <= 228) {
      margins = 'm-2';
      displayRates = 'block';
      paddings = 'p-2';
      bookButtonClass = 'py-2 px-4 text-xs';
      bookButtonMargins = 'my-4';
    }

    if(this.state.screenWidth <= 215) {
      margins = 'mx-0 my-2';
      displayRates = 'block';      
      paddings = 'p-2';
      bookButtonClass = 'py-2 px-4 text-xs';
      bookButtonMargins = 'my-4';
    }
    
    return (
      <div className={`text-center ${margins}`} style={{ maxWidth: '336px', minWidth: '200px', minHeight: '328px' }}>
        <div className={`bg-gray-100 rounded-lg drop-shadow-lg ${paddings}`}>
          { this.state.mentor.profile_picture_url &&
            <div className="flex justify-center">
              <img src={this.state.mentor.profile_picture_url}
                alt="Profile picture"
                className={classnames(
                  'rounded-full shadow-lg cursor-pointer',
                  { 'w-24 h-24': true }
                )}
              />
            </div>  
          }
  
          <h3 className="text-center text-sm text-gray-400 mb-6 mt-4">
            You can have 1-on-1 <br/> online sessions with me
          </h3>
          
          { this.state.mentor.rates &&
            <div className={`w-full ${ displayRates }`}>
              { Object.keys(this.state.mentor.rates).map((duration, index) =>
                <div className="flex-1 text-center mb-2" key={index}>
                  <p className="text-sm text-gray-500">
                    {duration} mins
                  </p>
        
                  <p className="text-xl">
                    { `$${this.state.mentor.rates[duration]}` }
                  </p>
                </div>
              )}
            </div>
          }

          <div className={bookButtonMargins}>
            <a
              href={url}
              className={classnames(
                { 'py-4 px-8' : true },
                'rounded-lg',
                { 'bg-[#00ADA5] hover:bg-[#05927D]': true },
                'text-sm text-center text-white',
                { 'w-full': true },
                bookButtonClass
              )}
              target="_blank"
            >
              BOOK ME ON SIDETRAIN
            </a>
          </div>
        </div>
      </div>
    )
  }
}


export default withRouter(Widget)